import React from 'react';
import {
  Alert,
  AlertTitle,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';

import Panel from '../ui/Panel';

const CATEGORIES = ['Project', 'Toil', 'Unplanned', 'Change', 'Learn'];

const FILTERS = [
  ['uncategorized', 'Currently Uncategorized'],
  ['all', 'All Tickets'],
  ['keyword', 'Containing Keyword'],
];

/** Bulk-apply a category label to a filtered set of tickets. */
const CategoryManagementSection = ({ options, onChange, onApply, loading }) => (
  <Panel
    title="Category Management"
    subtitle="Apply labels to tickets in bulk. Tickets are categorized based on their labels."
  >
    <Alert severity="info" sx={{ mb: 2 }}>
      <AlertTitle>How categorization works</AlertTitle>
      Tickets are categorized first by looking for specific labels (project, toil, unplanned,
      change, learn), and then by analyzing the summary and description if no explicit labels are
      found.
    </Alert>

    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControl fullWidth size="small">
          <InputLabel id="bulk-category-label">Category</InputLabel>
          <Select
            labelId="bulk-category-label"
            id="bulk-category"
            name="bulkCategory"
            value={options.category}
            label="Category"
            onChange={onChange}
          >
            <MenuItem value="">Select Category</MenuItem>
            {CATEGORIES.map((c) => (
              <MenuItem key={c} value={c}>
                {c}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <FormControl fullWidth size="small">
          <InputLabel id="bulk-filter-label">Filter</InputLabel>
          <Select
            labelId="bulk-filter-label"
            id="bulk-filter"
            name="bulkFilter"
            value={options.filter}
            label="Filter"
            onChange={onChange}
          >
            {FILTERS.map(([value, label]) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      {options.filter === 'keyword' && (
        <Grid size={{ xs: 12 }}>
          <TextField
            fullWidth
            size="small"
            label="Keyword"
            name="keyword"
            value={options.keyword}
            onChange={onChange}
            placeholder="Enter keywords to filter tickets"
            helperText="Use commas to separate multiple keywords"
          />
        </Grid>
      )}
    </Grid>

    <Stack direction="row" justifyContent="flex-end">
      <Button
        variant="contained"
        onClick={onApply}
        disabled={loading || !options.category}
        startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <CategoryIcon />}
      >
        {loading ? 'Updating…' : 'Apply Category Labels'}
      </Button>
    </Stack>
  </Panel>
);

export default CategoryManagementSection;
